<script lang="ts">
import { defineComponent } from 'vue';
import { usePoolsStore } from '@/stores/pools';
import { mapState } from 'pinia';
import CustomSelect from '@/components/custom-select.vue';

export default defineComponent({
  name: 'pools-filters',
  components: { CustomSelect },
  computed: {
    ...mapState(usePoolsStore, ['poolTypeIds']),
    poolId: {
      get() {
        return this.modelValue;
      },
      set(v: number) {
        this.$emit('update:modelValue', v);
      },
    },
  },
  emits: ['update:modelValue'],
  props: ['modelValue'],
});
</script>

<template>
  <span class="pt-2 text-sm mr-1">
    Только пулы c типом:
  </span>
  <custom-select
    class="bg-gray-200 dark:bg-gray-800 mb-1"
    placeholder="[Все]"
    :options="poolTypeIds || []"
    :use-null="true"
    null-name="[Все]"
    label-name="name"
    value-name="id"
    v-model="poolId"
  />
</template>

<style scoped lang="scss"></style>